import React from "react";
import ProcessParticipantPersonForm from "./ProcessParticipantPersonForm";
import { Box, Grid } from "@mui/material";
import _ from "lodash";
import { scrollToAnchor } from "../../../../theme/commonStyles";
import { ProductUnion } from "../../../../types/ProductUnion";

type ProcessParticipantsPeopleFormProps = {
  product: ProductUnion;
  refreshPage: Function;
};
const ProcessParticipantsPeopleForm = ({ product, refreshPage }: ProcessParticipantsPeopleFormProps) => {
  return (
    <Grid container>
      {_.map(_.sortBy(product.processParticipantsPeople, "id"), (participant) => (
        <Grid key={participant.id} size={12}>
          <Box sx={scrollToAnchor} id={"processParticipantPerson" + participant.id} />
          <ProcessParticipantPersonForm product={product} participant={participant} refreshPage={refreshPage} />
        </Grid>
      ))}
    </Grid>
  );
};
export default ProcessParticipantsPeopleForm;
